import Link from 'src/components/primitives/Link/Link';
import { WithChildren } from 'src/utils/UtilityTypes';

export default function ReferencePriceTooltipContent({
	children,
}: WithChildren) {
	return (
		<>
			<p>Reference Price is currently used for trigger orders. {children}</p>
			<Link
				href="https://docs.drift.trade/trading/all-order-types#trigger-order-mechanics"
				openInNewTab
			>
				Learn more
			</Link>
		</>
	);
}
